import React, { FC, Fragment, useEffect, useState } from 'react';

interface ScriptLoaderProps {
  children: React.ReactNode;
}
const ScriptLoader: FC<ScriptLoaderProps> = ({ children }) => {
  const [isReady, setIsReady] = useState(false);
  const maxWaitTime = 3000;
  const checkInterval = 100;

  useEffect(() => {
    let elapsed = 0;

    const interval = setInterval(() => {
      elapsed += checkInterval;

      const recaptchaReady = (window as any).grecaptcha;
      const mapsReady = window.google && window.google.maps && window.google.maps.Map;

      if ((recaptchaReady && mapsReady) || elapsed >= maxWaitTime) {
        setIsReady(!!recaptchaReady && !!mapsReady);
        clearInterval(interval);
      }
    }, checkInterval);

    return () => clearInterval(interval);
  }, []);

  if (!isReady) {
    return <div></div>;
  }

  return <Fragment>{children}</Fragment>;
};

export default ScriptLoader;
